import { useTranslation } from 'react-i18next';

interface ThemeTransitionOverlayProps {
    isTransitioning: boolean;
}

/**
 * A curtain drawn over the app while the theme swaps.
 *
 * The swap repaints every surface at once, which reads as a flicker; blurring
 * the page for the two seconds it takes turns that into a deliberate pause.
 */
export const ThemeTransitionOverlay: React.FC<ThemeTransitionOverlayProps> = ({ isTransitioning }) => {
    const { t } = useTranslation();

    if (!isTransitioning) return null;

    return (
        <div className="pointer-events-none fixed inset-0 z-[99999] flex animate-in items-center justify-center bg-black/60 backdrop-blur-xl fade-in duration-500">
            <p className="animate-pulse text-lg font-medium tracking-wide text-white">
                {t('THEME.SWITCHING')}
            </p>
        </div>
    );
};
